// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_kPk","cls2":"ReferenceEvaluationPage-cls2_nE0 ReferenceEvaluationPage-cls1_kPk"};